import { render } from "./Inbox.vue?vue&type=template&id=3f377006&ts=true"
import script from "./Inbox.vue?vue&type=script&lang=ts"
export * from "./Inbox.vue?vue&type=script&lang=ts"

import "./Inbox.vue?vue&type=style&index=0&id=3f377006&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__